import { Component, OnInit, Type, ViewChild } from "@angular/core";
import { CommonHelper } from "../../../shared/helpers/CommonHelper";
import { Search } from "../../../models/Search.model";
import { ProjectFinancialService } from "../../../services/projectFinancial.service";
import { ProjectCostService } from '../../../services/project-cost.service';
import { CompanyFinancial } from "../../../models/project/CompanyFinancial.model";
import { ProjectFinancial } from "../../../models/project/ProjectFinancial.model";
import { DropDownList } from "../../../models/DropDownList.model";
import { CompanyService } from "../../../services/billing-letter/company.service";
import { CompanyGroup } from "../../../models/billing-letter/CompanyGroup.model";
import { Json2csvService } from "../../../services/json2csv.service";
import { projectCostSearchFactory } from "../../../shared/factories/project-cost/project-cost.search.factory";
import * as _ from "lodash";
import { ToastsManager } from "ng2-toastr";
import { CompetenceProvider } from "../../../shared/providers/enums/billing-letter/competence-provider";
import { Router } from '@angular/router';
import { UtilsProjectCost } from '../utils';
import { ErrorHandlerProvider } from '../../../shared/providers/errorHandler.provider';

interface iConsultantCost {
    _id: string;
    active: boolean;
    fcEmail: string;
    name: string;
    mensalHours: number;
    total: number;
    valuePerHour: number;
    kind: number;
    honorarium: number;
}
@Component({
    selector: "app-projects-cost-create",
    templateUrl: "./projects-cost-create.component.html",
    styleUrls: ["./projects-cost-create.component.css"],
})
export class ProjectsCostCreateComponent implements OnInit {
    @ViewChild("clientMultiselect") clientMultiselect;
    @ViewChild("projectsMultiselect") projectsMultiselect;
    loading: boolean;
    projects: ProjectFinancial[] = new Array<ProjectFinancial>();
    companies: CompanyFinancial[] = new Array<CompanyFinancial>();
    findResults: Search = new Search();
    projectCostSearch = new projectCostSearchFactory();
    commonHelper: CommonHelper = new CommonHelper();
    project: ProjectFinancial = new ProjectFinancial();
    dropDownProjects = {
        dropDownList: new Array<DropDownList>(),
        selectedItems: new Array<DropDownList>(),
        dropDownSettings: {},
        commonHelper: new CommonHelper(),
    };
    dropDownClient = {
        dropDownList: new Array<DropDownList>(),
        selectedItems: new Array<DropDownList>(),
        dropDownSettings: {},
        commonHelper: new CommonHelper(),
    };
    dropDownCompanyGroups: CompanyGroup[];
    dropDownListMonths: DropDownList[] = new Array<DropDownList>();
    selectedCompanyGroupsItems: DropDownList[] = new Array<DropDownList>();
    selectedMonthsItems: DropDownList[] = new Array<DropDownList>();
    dropDownCompanyGroupsList = new Array<DropDownList>();
    dropDownMonthsSettings = {};
    dropDownCompanyGroupsSettings = {};
    sectionSearch: boolean;
    consultantByProject: iConsultantCost[] = [];
    estimatedHours: Array<string> = [];
    months: Array<any> = [];
    selectedMonthsItemsList: Array<any> = [];
    selectedMonthsItemsListIndex: any;
    projectTotalCost: any[] = [];
    competences = this.competenceProvider.competences;
    blockedSearch: boolean = true;
    researched: boolean = false;
    projectSearch;

    constructor(
        private projectsFinancial: ProjectFinancialService,
        private companyService: CompanyService,
        private toastr: ToastsManager,
        private json2csvService: Json2csvService,
        private competenceProvider: CompetenceProvider,
        private projectionService : ProjectCostService,
        private router: Router,
        private utilsProjectCost: UtilsProjectCost,
        private errorHandler: ErrorHandlerProvider
    ) { }

    async ngOnInit() {
        this.loading = true;
        const response = await this.projectsFinancial.getProjectsAndCustomers();
        this.projects = response.projects;
        this.months = this.utilsProjectCost.multiSelectMonthsAndYearsInit();
        await this.populateCompanies();
        this.populateProjects();
        this.dropDownCompanyGroupsSettings = this.commonHelper.getDropDownSettings(true, "Grupo de empresa", true, "", "", true, null, "");
        this.dropDownMonthsSettings = this.commonHelper.getDropDownSettings(false, "Meses", true, "Marcar todos os meses", "Desmarcar todos os meses", true, null, "");
        this.dropDownListMonths = this.commonHelper.getDropDownListItems(this.months, "_id", "name");
        this.dropDownProjects.dropDownSettings = this.commonHelper.getDropDownSettings(true, "Projetos", true, "", "", true, null, "", true);
        this.loading = false;
    }

    async Search(): Promise<void> {
        this.sectionSearch = false;
        this.researched  = false;
        this.estimatedHours = [];
        this.selectedMonthsItems = [];
        this.selectedMonthsItemsList = [];
        this.findResults = new Search();
        if (this.dropDownProjects.selectedItems && !this.dropDownProjects.selectedItems.length) {
            this.toastr.warning(`Selecione um projeto para realizar a busca.`, 'Campo para busca inválido');
            return
        }
        this.projectSearch = await this.projectionService.getConsultantsByProject(this.dropDownProjects.selectedItems[0].id)
        if (this.projectSearch && this.projectSearch.consultants.length > 0) {
            this.consultantByProject = this.projectSearch.consultants;
            this.sectionSearch = true;
        } else this.researched = true;

        const currentYear = new Date().getFullYear()
        let currentMonth = this.months.find((m) => `${m._id}` === `${String(new Date().getMonth())}/${currentYear}`);
        let lengthResult = this.projectSearch.consultants.length > 0 ? this.projectSearch.consultants.length : 0;
        if (currentMonth) {
            this.selectedMonthsItems.push({
                id: currentMonth._id,
                itemName: currentMonth.name,
            });
        } else {
            currentMonth = this.months.find((m) => `${m._id}` === `${String(new Date().getMonth())}${currentYear}`);
        }
        this.projectCostSearch.months.push(currentMonth._id);
        if (lengthResult !== 0) {
            for (let i = 0; i < lengthResult; i++) {
                this.selectedMonthsItemsList[i] = [
                    { id: currentMonth._id, itemName: currentMonth.name },
                ];
            }
        }
    }

    async populateCompanies(): Promise<void> {
        this.companies = await this.projectsFinancial.getAllCompany(false);
        this.dropDownCompanyGroups = await this.companyService.getAllCompanyGroups();
        this.dropDownClient = this.projectsFinancial.createPropertyObjDropDown(this.companies, true, "Cliente", "clientes", ["group"], "group");
        this.dropDownClient.dropDownList.forEach((item: DropDownList) =>(item.group = this.commonHelper.transcriptDivisionGroup(parseInt(item.group))));
        this.dropDownCompanyGroups.forEach((item: CompanyGroup) => {
            this.dropDownCompanyGroupsList.push({
                id: item._id,
                itemName: item.name,
            });
        });
    }

    populateProjects(): void {
        this.dropDownProjects = this.projectsFinancial.createPropertyObjDropDown(this.projects, true, "Projetos", "projetos");
    }

    async onChangeCompanyGroup(): Promise<void> {
        this.dropDownClient.selectedItems = [];
        this.dropDownProjects.selectedItems = [];
        this.sectionSearch = false;
        this.researched = false;
        if (this.selectedCompanyGroupsItems.length > 0) {
            const companiesByGroupId =
                await this.companyService.getCompaniesByGroupIdForProjectsCost(
                    this.selectedCompanyGroupsItems[0].id
                );
            this.dropDownClient.dropDownList = this.commonHelper.getDropDownListItems(companiesByGroupId, "_id", "name", ["group"]);
            this.dropDownClient.dropDownSettings = this.commonHelper.getDropDownSettings(true, "Cliente", false, `Marcar todos os clientes`, `Desmarcar todos os clientes`, true, "group", "");
            this.dropDownClient.dropDownList.forEach(
                (item: DropDownList) =>
                (item.group = this.commonHelper.transcriptDivisionGroup(parseInt(item.group)))
            );
            this.clientMultiselect.settings.disabled = false;
        } else {
            this.clientMultiselect.settings.disabled = true;
            this.projectsMultiselect.settings.disabled = true;
        }
    }

    changeCustomer(): void {
        this.dropDownProjects.selectedItems = [];
        this.sectionSearch = false;
        this.researched = false;
        if (this.dropDownClient.selectedItems.length > 0) {
            const selectedCustomer = _.filter(this.companies, {
                _id: this.dropDownClient.selectedItems[0].id,
            });
            this.dropDownProjects.dropDownList =
                this.commonHelper.getDropDownListItems(
                    this.projects.filter((x: ProjectFinancial) =>
                            x.companyId == selectedCustomer[0]._id
                    ),
                    "_id",
                    "name"
                );

            if(this.dropDownProjects.dropDownList.length > 0) {
                this.projectsMultiselect.settings.disabled = false;
            } else {
                this.projectsMultiselect.settings.disabled = true;
                this.toastr.warning("Não possui projeto alocado");
            }
        } else {
            this.projectsMultiselect.settings.disabled = true;;
        }
    }

    changeProject() : void{
        this.sectionSearch = false;
        this.researched = false;
        if (this.dropDownClient.selectedItems.length > 0) this.blockedSearch = false;
        else this.blockedSearch = true;
    }

    onChange(index) {
        this.selectedMonthsItemsListIndex = index;
    }

    verifyEstimatedHoursAndMonths(): boolean {
        const consultantCount = this.consultantByProject.length;
        const estimatedHoursCount = this.estimatedHours.length;
        let competences = 0;
        this.selectedMonthsItemsList.map(m => {
            if(m.length > 0) competences += 1;
        });
        if (consultantCount !== estimatedHoursCount || competences !== estimatedHoursCount ) {
            this.toastr.warning(
                `Preencha os campos Horas Estimadas e Competência em Meses para gerar uma Projeção de Custo.`,
                "FORMULÁRIO INVÁLIDO"
            );
            return false;
        }
        return true;
    }

    calculate() {
        const csvLines = [];
        this.consultantByProject.forEach((consultant, index) => {
            const contractType = this.commonHelper.transcriptContractType(consultant.kind);
            const months = this.getMonths(this.selectedMonthsItemsList[index]);
            const cost = consultant.valuePerHour * parseInt(this.estimatedHours[index]);

            months.forEach((month) => {
                csvLines.push({
                    id: index,
                    name: consultant.name,
                    fcEmail: consultant.fcEmail,
                    contractType: contractType !== "" ? contractType : "-",
                    valuePerHour: Number(consultant.valuePerHour).toLocaleString("pt-BR",{maximumSignificantDigits : 4}),
                    cost,
                    competence: month,
                    honorarium: consultant.honorarium
                });
            });
        });
        this.projectTotalCost = csvLines;
    }

    async export() {
        if (!this.verifyEstimatedHoursAndMonths()) return;
        this.calculate();
        this.json2csvService.export(
            this.projectTotalCost.map((csvLine) => {
                return {
                    "Consultores":          csvLine.name ? csvLine.name : '-',
                    "Tipo de Contrato":     csvLine.contractType ? csvLine.contractType : '-',
                    "Honorario":            csvLine.honorarium ? this.commonHelper.transcriptHonorariumType(csvLine.honorarium) : '-',
                    "Cliente":              this.projectSearch.company ? this.projectSearch.company.name : '-',
                    "Grupo de Empresa":     this.projectSearch.companyGroup ? this.projectSearch.companyGroup.name : this.selectedCompanyGroupsItems[0].itemName,
                    "Projeto":              this.projectSearch.name,
                    "Tipos de Serviços":    this.projectSearch.subDivision ? this.projectSearch.subDivision.name : '-',
                    "Horas Estimadas":      this.estimatedHours ? this.estimatedHours[csvLine.id] : '-',
                    "Valor Total Hora":     csvLine.valuePerHour ? csvLine.valuePerHour.toFixed(2) : '-',
                    "Competência":          csvLine.competence.slice(0, -5),
                    "Ano":                  csvLine.competence.slice(-4),
                    "Projeção de Custos":   csvLine.cost ? csvLine.cost.toLocaleString("pt-BR",{maximumSignificantDigits : 6}) : '-'
                };
            }),
            `Projeção ${this.projectSearch.name}- ${new Date().toLocaleDateString('pt-br')}`
        );
    }

    async save() {
        if (!this.verifyEstimatedHoursAndMonths()) return;
        let projection = this.calculateSave();

        try {
            let res = await this.projectionService.createProjectionCust(projection);
            if(res._id) {
                this.loading = true;
                this.toastr.success('Projeção cadastrada com sucesso!');
                this.router.navigate(['/projects-cost']);
                this.loading = false;
            } else {
                this.errorHandler.interceptError(res, 'Projeção de custo');
            }
        } catch(err) {
            this.errorHandler.interceptError(err, 'Projeção de custo');
        }
    }

    calculateSave() {
        let newConsultants = [];
        let totalValue = 0;
        this.consultantByProject.map((consultant, index) => {
            let horaValue = this.estimatedHours[index];
            let projectCost = consultant.valuePerHour * Number(horaValue);
            let newCompetence = [];
            totalValue += projectCost
            this.selectedMonthsItemsList[index].map(date => newCompetence.push({
                month: Number(date.id.slice(0, -5)),
                year: Number(date.id.slice(-4))
            }));
            newConsultants.push({
                _id: consultant._id,
                name: consultant.name,
                hourValue: consultant.valuePerHour,
                estimatedHours: horaValue,
                kind: consultant.kind,
                projectCost: projectCost.toFixed(2),
                competences: newCompetence,
                honorarium: consultant.honorarium
            });
        })

        return {
            totalValue: totalValue.toFixed(2),
            consultants: newConsultants,
            project: {
                _id: this.projectSearch._id,
                name: this.projectSearch.name,
                subDivision: this.projectSearch.subDivision,
            },
            customer: {
                _id: this.projectSearch.company._id,
                name: this.projectSearch.company.name
            },
            companyGroup: this.projectSearch.companyGroup ? { ...this.projectSearch.companyGroup } :
                { _id: this.selectedCompanyGroupsItems[0].id, name: this.selectedCompanyGroupsItems[0].itemName }
        }
    }

    getMonths(months: string[]): string[] {
        const allMonths = months.reduce((acc, current) => acc.concat(current), []).map(month => month.itemName);
        return allMonths.sort((a, b) => a - b);
    }
}



// WEBPACK FOOTER //
// ./src/app/views/project-cost/project-cost-create/projects-cost-create.component.ts